export enum EidEasyFailReason {
  OtherActiveDoc = 'other_active_doc',
  DocExpired = 'doc_expired',
  Unknown = 'unknown',
}
